export default "__VITE_ASSET__320b973d__"